import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3044ee10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "message-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      ref: "tableRef",
      dense: "",
      "virtual-scroll": "",
      "virtual-scroll-item-size": 28,
      class: "full-height",
      title: "",
      rows: _ctx.logmessages,
      filter: _ctx.filter + '|' + _ctx.dateFrom + '|' + _ctx.dateTo + '|' + _ctx.levelFilter,
      "filter-method": _ctx.customFilter,
      columns: _ctx.columns,
      "rows-per-page-label": _ctx.t('logs.messagesperpage'),
      pagination: { rowsPerPage: 1000 },
      "row-key": "name"
    }, {
      "bottom-row": _withCtx(() => [
        _createVNode(_component_q_btn, {
          color: "grey-7",
          "icon-right": "archive",
          label: _ctx.t('tags.exporttocsv'),
          "no-caps": "",
          onClick: _ctx.exportTable
        }, null, 8, ["label", "onClick"])
      ]),
      body: _withCtx((props) => [
        _createVNode(_component_q_tr, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_td, {
              key: "datetime",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatDateTime(props.row.datetime)), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "level",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.level), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "message",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.truncateMessage(props.row.message)) + " ", 1),
                  (props.row.message.length > 130)
                    ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      top: _withCtx(() => [
        _createVNode(_component_q_checkbox, {
          label: _ctx.t('logs.debug'),
          modelValue: _ctx.debug,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.debug) = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDebugChange()))
          ]
        }, null, 8, ["label", "modelValue"]),
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.autoscroll,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.autoscroll) = $event)),
          class: "q-ml-md",
          label: _ctx.t('logs.autoscroll')
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_q_space),
        _createVNode(_component_q_input, {
          type: "datetime-local",
          modelValue: _ctx.dateFrom,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateFrom) = $event)),
          dense: "",
          class: "q-ml-sm"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_q_input, {
          type: "datetime-local",
          modelValue: _ctx.dateTo,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateTo) = $event)),
          dense: "",
          class: "q-ml-sm"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_q_select, {
          dense: "",
          class: "q-ml-sm",
          modelValue: _ctx.levelFilter,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.levelFilter) = $event)),
          options: ['DEBUG', 'INFO', 'WARN', 'ERROR'],
          "emit-value": "",
          "map-options": "",
          clearable: "",
          label: _ctx.t('logs.level')
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_q_space),
        _createVNode(_component_q_input, {
          dense: "",
          debounce: "300",
          color: "primary",
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter) = $event))
        }, {
          append: _withCtx(() => [
            _createVNode(_component_q_icon, { name: "search" })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_btn, {
          class: "q-ml-sm",
          color: "grey-6",
          icon: "clear",
          label: _ctx.t('logs.clear'),
          "no-caps": "",
          onClick: _ctx.clearMessages
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }, 8, ["rows", "filter", "filter-method", "columns", "rows-per-page-label"])
  ]))
}